import React, { useState, useEffect } from 'react'
import { encode, decode } from 'shopify-gid'

import { PageLink } from 'src/components/link'
import { Image } from 'src/components/image'
import { ProductForm } from './form'

import { client, useAddItemToCart } from 'src/context/siteContext'

export const ProductCard = ({
  main,
  shopify
}: Product ) => {
  return (
    <div className='grid__product c30 my1 x'>
      <div className='rel'>
        <div className='x mt05 p1 grid__product-form abs bottom left z1'>
          <ProductForm {...shopify} showQuantity={false} waitlist={false} addText={'Add to Cart'} />
        </div>

        <PageLink className='block' to={`/products/${main.slug.current}`}>
          {main.mainImage && (<Image className='block x' imageId={main.mainImage.asset.id} alt={main.title} />)}
        </PageLink>
      </div>
      <div className='aic mt05'>
        <PageLink className='block' to={`/products/${main.slug.current}`}>
          <div className='f jcb aic'>
            {main.linkedCollection && (
              <span className='caps h4 m0 p0'>/{main.linkedCollection.content.main.title}</span>
            )}
            <span className='caps h4 grid__product-price m0 p0'>${parseInt(shopify.defaultPrice).toFixed(0)}</span>
          </div>
          <h2 className='m0 caps p0'>{main.title}</h2>
        </PageLink>
      </div>
    </div>
  )
}

export interface Product {
  main: {
    title: string
    mainImage: {
      asset: {
        _ref: string
      }
    }
    slug: {
      current: string
    }
  }
  shopify: {
    defaultPrice: string
    productId: number
  }
}